import * as React from 'react';
import Image from 'next/image';

// Import all benefit images
import earth from '@/components/Icons/Benefits/img/earth.png';
import heart from '@/components/Icons/Benefits/img/heart.png';
import apple from '@/components/Icons/Benefits/img/apple.png';
import megaphone from '@/components/Icons/Benefits/img/megaphone.png';

// Define the available icon types (updated to match PNG filenames)
export type BenefitIconType = 'earth' | 'heart' | 'apple' | 'megaphone';
interface BenefitIconProps {
  alt?: string;
  className?: string;
  type: BenefitIconType;
}

// Map icon types to their corresponding images and default alt text
const iconMap = {
  earth: {
    src: earth,
    alt: 'Earth'
  },
  heart: {
    src: heart,
    alt: 'Heart'
  },
  apple: {
    src: apple,
    alt: 'Apple'
  },
  megaphone: {
    src: megaphone,
    alt: 'Megaphone'
  }
} as const;
const _BenefitIcon = ({
  type,
  className = 'max-md:size-14 aspect-square object-contain',
  alt
}: BenefitIconProps) => {
  const icon = iconMap[type];
  return <Image alt={alt || icon.alt} className={className} sizes="(max-width: 768px) 56px, 100px" src={icon.src} data-sentry-element="Image" data-sentry-component="_BenefitIcon" data-sentry-source-file="BenefitIcon.tsx" />;
};
const BenefitIcon = React.memo(_BenefitIcon);
export default BenefitIcon;